import { render, staticRenderFns } from "./TeamAttendanceUploadDetails.vue?vue&type=template&id=5b8b4c98"
import script from "./TeamAttendanceUploadDetails.vue?vue&type=script&lang=js"
export * from "./TeamAttendanceUploadDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports